import axios from "shared/api/axiosConfig";


export async function sendResultByEmail(email, userType, contenuReponseShareID, isOwner, uid) {
	const url = 'client/sendResultByEmail';
	const formData = new FormData();

	formData.append('type', userType);
	//console.log('type', userType);
	formData.append('email', email);
	//console.log('email', email);
	// Ajout des données sous forme de JSON stringifié
	formData.append('data', JSON.stringify(contenuReponseShareID));
	//console.log('data', JSON.stringify(contenuReponseShareID));
	formData.append('isOwner', isOwner);
	//console.log('isOwner', isOwner);
	formData.append('uid', uid);
	//console.log('uid', uid);
	try {
		const response = await axios.post(url, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});

		if (response.status === 200) {
			return response.data; // PDF généré avec succès
		}

		if (response.status === 400) {
			throw new Error("Requête invalide : informations manquantes ou invalides.");
		}

	} catch (error) {
		if (error.response) {
			if (error.response.status === 400) {
				throw new Error(error.response.data.message || "Données invalides.");
			} else if (error.response.status === 500) {
				throw new Error("Une erreur interne est survenue lors de la génération du PDF.");
			}
		}
		throw new Error("Impossible de contacter le serveur.");
	}
}

